require('bootstrap/js/dist/tooltip');

$(document).ready(function () {

    // enable tooltips
    $('[data-toggle="tooltip"]').tooltip();
});
